import { handleAxiosError } from 'core/notifications';
import i18n from 'i18next';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import getAsyncOptionsConfig from '../helpers/getAsyncOptionsConfig';

import axios from '@/util/axios';

export default ({ isEnabled, param, searchQuery, selection, extraParams = {} }) => {
  const {
    getOptionsAxiosConfig = () => {},
    getSelectedLabelAxiosConfig = () => {},
    placeholder = i18n.t('search'),
  } = getAsyncOptionsConfig(param);

  const selectedValue = selection[0];

  const asyncOptions = useInfiniteQuery({
    enabled: isEnabled,
    getNextPageParam: ({ pagination }) => {
      if (pagination && !pagination.is_last_page) return pagination.page + 1;
    },
    onError: handleAxiosError,
    queryFn: async ({ pageParam }) =>
      (await axios(getOptionsAxiosConfig({ pageParam, searchQuery, extraParams }))).data,
    queryKey: ['options', param, searchQuery, extraParams],
  });

  const selectedLabel = useQuery({
    enabled: isEnabled && selectedValue !== undefined,
    onError: handleAxiosError,
    queryFn: async () => (await axios(getSelectedLabelAxiosConfig({ id: selectedValue }))).data,
    queryKey: ['label', param, selectedValue],
  });

  return { asyncOptions, placeholder, selectedLabel };
};
